import { useMutation } from '@apollo/client/react';
import { useCallback, useState } from 'react';

import {
  CancelAppointmentReason,
  CancelPrescriptionAppointmentWithLineVisitorDocument,
} from '~/graphql/generated/graphql';

export const useCancelAppointmentWithoutMessage = (appointmentId: string) => {
  const [isCanceling, setIsCanceling] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [cancelWithLineVisitor] = useMutation(CancelPrescriptionAppointmentWithLineVisitorDocument);

  const handleCancel = useCallback(
    async (reason: CancelAppointmentReason) => {
      if (!appointmentId) return;

      try {
        setIsCanceling(true);

        await cancelWithLineVisitor({
          variables: {
            input: {
              appointmentId,
              messageSendable: false,
              reason,
            },
          },
        });
      } catch (_error) {
        setError(_error?.message || 'エラーが発生しました');
      } finally {
        setIsCanceling(false);
      }
    },
    [appointmentId, cancelWithLineVisitor],
  );

  return {
    canceling: isCanceling,
    error,
    handleCancel,
  };
};
